<template>
    <bar-desktop v-if="isDesktop"></bar-desktop>
    <bar-mobile v-else></bar-mobile>
</template>
<script>
import ScrollMagic from "scrollmagic"
import barAppDesktop from "./bar-app-desktop.vue"
import barAppMobile from "./bar-app-mobile.vue"
//import barAppMobileProfile from "./bar-app-mobile-profile.vue"

export default {
    components: {
        'bar-desktop': barAppDesktop,
        'bar-mobile': barAppMobile,
    },
    data: () => ({
        scrollController: null,
        scene: null
    }),
    mounted() {
        this.$nextTick(() => {
            // Initializing scroll controller
            if(this.isDesktop) this.createScrollController()
        })
    },

    methods: {
        /* 
         * Adding scroll scenes
         */
        createScrollController() {
            //Creating controller and Adding scenes
            this.scrollController = new ScrollMagic.Controller()
            this.classToggleScene()
        },

        classToggleScene() {
            //Creating scene
            this.scene = new ScrollMagic.Scene({
                    triggerHook: "onLeave",
                    offset: this.$store.state.common.scrollOffset
                })
                .setClassToggle(this.$el, 'main-app-bar--scrolled')
                .addTo(this.scrollController)
        }
    }
}
</script>